import {
    AssetLink,
    ContentfulEntryContract,
    ContentfulEntryContractFields,
    ContentfulEntryFromContract,
    isContentfulEntrySysContract,
} from './contracts';

export type ImageLocation = 'image-on-left' | 'image-on-right';

export interface LandingPageSectionContentFields
    extends ContentfulEntryContractFields {
    image?: AssetLink;
    imageLocation?: ImageLocation;
    text?: string;
    title?: string;
}

export type LandingPageSectionContract = ContentfulEntryContract<
    LandingPageSectionContentFields,
    'landingPageSection'
>;

export type LandingPageSectionContent =
    ContentfulEntryFromContract<LandingPageSectionContract>;

export class LandingPageSection {
    private contract: Partial<LandingPageSectionContent>;

    constructor(contract: Partial<LandingPageSectionContent> = {}) {
        this.contract = contract;
    }

    get contentType(): string {
        return 'landingPageSection';
    }

    get imageUrl(): string {
        return this.contract.fields?.image?.fields.file?.url ?? '';
    }

    get imageLocation(): string {
        return this.contract.fields?.imageLocation ?? '';
    }

    get text(): string {
        return this.contract.fields?.text ?? '';
    }

    get title(): string {
        return this.contract.fields?.title ?? '';
    }
}

export function isLandingPageSectionContent(
    thing: unknown
): thing is LandingPageSectionContent {
    return (
        thing !== null &&
        typeof thing === 'object' &&
        'sys' in thing &&
        thing.sys !== null &&
        isContentfulEntrySysContract(thing.sys) &&
        thing.sys.contentType?.sys.id === 'landingPageSection'
    );
}
